import { render, staticRenderFns } from "./PhoneNumberMenu.vue?vue&type=template&id=505d6b3d&scoped=true"
import script from "./PhoneNumberMenu.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d6b3d",
  null
  
)

export default component.exports